export interface ILoadingScreen {
    show(): void;

    hide(): void;
}

export class LoadingScreen implements ILoadingScreen {
    constructor(private el: HTMLElement) {
    }

    public show(): void {
        this.el.style.display = 'flex';
    }

    public hide(): void {
        this.el.style.display = 'none';
    }
}
